import { render, staticRenderFns } from "./homeDetail.vue?vue&type=template&id=4ea5cab8&scoped=true&"
import script from "./homeDetail.vue?vue&type=script&lang=js&"
export * from "./homeDetail.vue?vue&type=script&lang=js&"
import style0 from "./homeDetail.vue?vue&type=style&index=0&id=4ea5cab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5cab8",
  null
  
)

export default component.exports